module.exports = require('./lib/heap');



/*****************
 ** WEBPACK FOOTER
 ** ./~/heap/index.js
 ** module id = 148
 ** module chunks = 0
 **/